"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _ = require("../..");

var _mobxReact = require("mobx-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

require("./Alert.css");

var _styles = {
  "container": "Alert__container___1godD",
  "message": "Alert__message___2Swsz",
  "actions": "Alert__actions___3MICY",
  "multiple": "Alert__multiple___3OW4x",
  "link": "Alert__link___2DcYs",
  "icon": "Alert__icon___3ppFz",
  "info": "Alert__info___18O_G",
  "success": "Alert__success___2b0fC",
  "alert": "Alert__alert___3e3o5",
  "danger": "Alert__danger___TaPWv",
  "warning": "Alert__warning___K1wRA",
  "caution": "Alert__caution___gwXDH",
  "in_card": "Alert__in_card___3ZkYY",
  "inline": "Alert__inline___en930",
  "card": "Alert__card___Zyxsu",
  "top": "Alert__top___3Wzuf",
  "bottom": "Alert__bottom___J4LrE",
  "top-bottom": "Alert__top-bottom___2Dqnu",
  "left": "Alert__left___a7GWO"
};

const styles = _bind.default.bind(_styles);

const AlertRoot = (0, _react.forwardRef)(({
  className,
  dataTestId,
  text,
  variant = 'primary',
  type = 'info',
  icon,
  actions,
  messageIconGap = 8,
  inCardBorder,
  iconColor,
  backgroundColor = _.Color.neutral.white,
  ...props
}, ref) => {
  const composed_classname = (0, _bind.default)(styles('container', variant, type, inCardBorder), className);
  const style = {
    backgroundColor
  };

  const getIconName = type => {
    switch (type) {
      case 'success':
        return _.IconEnum.check_circle;

      case 'alert':
        return _.IconEnum.exclamation_circle;

      case 'danger':
        return _.IconEnum.exclamation_triangle;

      case 'caution':
        return _.IconEnum.exclamation_triangle;

      default:
        return _.IconEnum.info_circle;
    }
  };

  const getIconColor = type => {
    switch (type) {
      case 'success':
        return _.Color.semantic.$success50;

      case 'alert':
      case 'danger':
        return _.Color.semantic.$error50;

      case 'warning':
        return _.Color.semantic.$warning50;

      case 'caution':
        return _.Color.semantic.$warning50;

      case 'info':
        return _.Color.blue._60;

      default:
        return _.Color.neutral._90;
    }
  };

  return _react.default.createElement("div", {
    className: composed_classname,
    "data-testid": dataTestId,
    ref: ref,
    ...props,
    style: style
  }, _react.default.createElement("div", {
    className: styles('message'),
    style: {
      gap: messageIconGap
    }
  }, _react.default.createElement(_.Icon, {
    name: icon || getIconName(type),
    color: iconColor ? iconColor : getIconColor(type)
  }), typeof text === 'string' ? _react.default.createElement(_.Text, {
    size: 15
  }, text) : _react.default.createElement(_react.default.Fragment, null, text)), actions && _react.default.createElement("div", {
    className: styles('actions', {
      multiple: Array.isArray(actions)
    })
  }, Array.isArray(actions) ? actions.map((item, i) => {
    return _react.default.createElement(_.Link, {
      key: i,
      dataTestId: dataTestId && `${dataTestId}-${item.text}`,
      href: item.href,
      target: item.external ? '_blank' : '_self',
      onClick: item.onClick && item.onClick,
      external: item.externalIcon,
      className: styles('link', {
        icon: item.externalIcon
      }),
      inheritColor: true
    }, item.text);
  }) : _react.default.createElement(_.Link, {
    dataTestId: dataTestId && `${dataTestId}-${actions.text}`,
    href: actions.href,
    target: actions.external ? '_blank' : '_self',
    onClick: actions.onClick && actions.onClick,
    external: actions.externalIcon,
    className: styles('link', {
      icon: actions.externalIcon
    }),
    inheritColor: true
  }, actions.text)));
});
AlertRoot.displayName = 'Alert';
const Alert = (0, _mobxReact.observer)(AlertRoot);
var _default = Alert;
exports.default = _default;